import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';

@Injectable()
export class GlobalHttpInterceptor implements HttpInterceptor {
  TIMESTAMP_REGEX = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/;

  constructor(
    public router: Router,
    private matSnackBar: MatSnackBar,
    private keycloakService: KeycloakService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.isWebcamRequest(req.url)) {
      const decodedUrl = this.decodeUrl(req.url);

      req = req.clone({
        url: decodedUrl,
      });

      const found = decodedUrl.match(this.TIMESTAMP_REGEX);

      if (found && this.isUtcSecondTimestamp(found[0])) {
        req = req.clone({
          responseType: 'blob' as 'json',
        });
      }
    }
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof Blob) {
          return throwError(() => error);
        }
        // API IS OFFLINE
        if (error.status === 0) {
          // @ToDo
          // Disable Snackbar for now

          // this.matSnackBar
          //   .open('Keine Verbindung möglich.', 'Seite neu laden', {
          //     // duration: 10000,
          //   })
          //   .afterDismissed()
          //   .subscribe((info) => {
          //     if (info.dismissedByAction) {
          //       window.location.reload();
          //     }
          //   });
          return EMPTY;
        } else if (error.status === 401) {
          // USER NOT AUTHORIZED
          // Redirect User to login page
          this.keycloakService.login();
        }
        console.error(error);
        return throwError(() => error.message);
      })
    );
  }

  private isWebcamRequest(url: string): boolean {
    return (
      url === environment.webcamEndpoint ||
      url.startsWith(`${environment.webcamEndpoint}/`)
    );
  }

  private decodeUrl(url: string): string {
    try {
      return decodeURIComponent(url);
    } catch {
      return url;
    }
  }

  private isUtcSecondTimestamp(value: string): boolean {
    const timestamp = Date.parse(value);

    return (
      Number.isFinite(timestamp) &&
      new Date(timestamp).toISOString() === value.replace(/Z$/, '.000Z')
    );
  }
}
